export class Endpoints {
    //Recipes
    static readonly recipes = '/recipes';
    static readonly recipesSliders = '/recipes/sliders';

    static readonly recipe = (id: string): string => `/recipes/${id}`;

    //Categories
    static readonly categories = '/categories';

    //Regions
    static readonly regions = '/regions';

    //Social Links
    static readonly socialLinks = '/socials';

    //Sliders
    static readonly sliders = '/sliders';

    //Banners
    static readonly banners = '/banners';

    //Translations
    static readonly translations = '/translations';

    //About
    static readonly about = '/about';

    // Site policies
    static readonly sitePolicies = '/site-policies';

    // Recipes
    static readonly sendRecipe = '/recipe/send';

    // Media
    static readonly uploadTemporaryMedia = '/media/temporary/upload';
    static readonly deleteTemporaryMedia = (uuid: string): string => `/media/${uuid}/delete`;

    // Newsletter
    static readonly subscribeNewsletter = '/subscribe';

    // Useful Links
    static readonly usefulLinks = '/useful-links';

    // Partners
    static readonly partners = '/transitions';

    // Settings
    static readonly settings = '/settings';

    // Languages
    static readonly languages = '/languages';

    // Resources
    static readonly resources = '/resources';
    static readonly resourcesLanguages = '/resources/languages';

    // News
    static readonly news = '/news';
    static readonly latestNews = '/news/latest';
    static readonly similarNews = (id: string): string => `/news/${id}/similar`;
    static readonly newsById = (id: string): string => `/news/${id}`;
    static readonly newsCategories = '/news/categories';

    // Events
    static readonly events = '/events';
    static readonly event = (id: string): string => `/events/${id}`;
    static readonly eventTypes = '/events/types';
    static readonly eventCategories = '/events/categories';
    static readonly eventCities = '/events/cities';
    static readonly similarEvents = (id: string): string => `/events/${id}/similar`;
    static readonly registerEvent = (id: string): string => `/events/${id}/register`;
    static readonly homeEvents = '/home/events';

    // Gallery
    static readonly gallery = '/galleries';
    static readonly galleryById = (id: string): string => `/galleries/${id}`;
    static readonly tags = '/galleries/tags';
    static readonly types = '/galleries/types';

    //Search
    static readonly searchCounts = '/tab-counts';
}
